import CancelScheduleSendIcon from "@material-ui/icons/CancelScheduleSend"
import React from "react"
import values from "~/const.scss"

const CustomCancelScheduleSendIcon = () => (
  <CancelScheduleSendIcon style={{ color: values.darkPurple }} />
)

export default CustomCancelScheduleSendIcon
